import { categoryIntro, works, type WorkCategory } from '@/mocks/animeWorks';
import WorkCard from './WorkCard';

const sectionMeta: Record<WorkCategory, { icon: string; accent: string; anchor: string }> = {
  校园: { icon: 'ri-graduation-cap-line', accent: 'bg-primary-100 text-primary-700', anchor: 'campus' },
  同居: { icon: 'ri-home-4-line', accent: 'bg-accent-100 text-accent-800', anchor: 'cohab' },
  暧昧: { icon: 'ri-heart-pulse-line', accent: 'bg-secondary-100 text-secondary-900', anchor: 'ambi' },
  逆后宫: { icon: 'ri-star-line', accent: 'bg-primary-100 text-primary-700', anchor: 'rev' },
};

const altBg: Record<WorkCategory, string> = {
  校园: 'bg-background-100/60',
  同居: 'bg-background-50',
  暧昧: 'bg-background-100/60',
  逆后宫: 'bg-background-50',
};

export default function CategorySection({ category }: { category: WorkCategory }) {
  const meta = sectionMeta[category];
  const list = works.filter((w) => w.category === category);

  return (
    <section id={meta.anchor} className={`scroll-mt-16 py-14 md:py-16 ${altBg[category]}`}>
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-8 flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
          <div className="flex items-start gap-4">
            <span
              className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-lg text-xl ${meta.accent}`}
            >
              <i className={meta.icon} />
            </span>
            <div>
              <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
                {category}系列
              </h2>
              <p className="mt-1.5 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
                {categoryIntro[category]}
              </p>
            </div>
          </div>
          <a
            href="#featured"
            className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-600 transition-colors hover:text-primary-700"
          >
            浏览更多
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((work) => (
            <WorkCard key={work.id} work={work} />
          ))}
        </div>
      </div>
    </section>
  );
}